/*=========================================================================================
  File Name: moduleBookingMutations.js
  Description: Booking Module Mutations
==========================================================================================*/

export default {
  SET_LIST(state, data) {
    state.list = data || [];
  },
  SET_PAGINATION(state, data) {
    state.pagination = { ...state.pagination, ...data };
  },
};
